export const GET_PROMO_OFFER_MAIL = "GET_PROMO_OFFER_MAIL";